import { useEffect } from "react";

const PAYPAL_SANDBOX_CLIENT_ID =
  "BAA3OKxL0uWCnr95eaF03IPug_vAWhyfGdPxpgDufv_tDyCG4TsNAn82ews66-Ryaxjz9br9u9inw96c5U";
const PAYPAL_PRODUCTION_CLIENT_ID =
  "AQ8N3sbhnGv5ImrvIfDp-7QvRJEa0xbXxvtGfnzZLB6BFlhXHHMq6jbdh_o7hNh-Yl64j1r1CsoA5jXN";
const PAYPAL_MESSAGES_SDK_ID = "paypal-pay-later-messages-sdk";

interface Props {
  amount: number;
}

export default function PayPalPayLaterMessage({ amount }: Props) {
  useEffect(() => {
    if (document.getElementById(PAYPAL_MESSAGES_SDK_ID)) return;

    const paypalClientId =
      window.location.hostname === "www.crazysales.com.au"
        ? PAYPAL_PRODUCTION_CLIENT_ID
        : PAYPAL_SANDBOX_CLIENT_ID;
    const script = document.createElement("script");
    script.id = PAYPAL_MESSAGES_SDK_ID;
    script.async = true;
    script.dataset.namespace = "PayPalSDK";
    script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=AUD&components=messages`;
    document.head.appendChild(script);
  }, []);

  if (!Number.isFinite(amount) || amount <= 0) return null;

  return (
    <div
      data-pp-message
      data-pp-style-layout="text"
      data-pp-style-logo-type="inline"
      data-pp-style-text-color="black"
      data-pp-style-text-size="12"
      data-pp-amount={amount.toFixed(2)}
      data-pp-placement="product"
    />
  );
}
